import defu from 'defu'
import type { FetchError } from 'ofetch'

// export interface CustomError {
//     status: number,
//     violations: {
//         propertyPath: string,
//         message: string
//     }[],
//     detail: string,
//     type: string,
//     title: string,
//     instance: string
// }

type FetchOriginType = <T>(
    request: Parameters<typeof useFetch<T>>[0],
    options?: Parameters<typeof useFetch<T>>[1]
) => ReturnType<typeof useFetch<T, FetchError>>;

export const useMyFetch: FetchOriginType = (request, options = {}) => {
    return useFetch(request, defu<typeof options, typeof options[]>(options, {
        $fetch: useNuxtApp().$api as typeof $fetch,
    }))
}
